import React from 'react';
import {
  Edit,
  SimpleForm,
  TextInput,
  BooleanInput,
  ReferenceInput,
  AutocompleteInput,
  required
} from 'react-admin';
import { ApiResource } from '../../lib/api';

const leftPad = (n: number) => (s: string | number) => {
  const str = String(s);
  return '0'.repeat(n - str.length) + str;
}
const leftPad4 = leftPad(4);
const leftPad2 = leftPad(2);
const convertDateToString = (value: Date) => {
    if (!(value instanceof Date) || isNaN(value.getDate())) return '';
    const yyyy = leftPad4(value.getFullYear());
    const MM = leftPad2(value.getMonth() + 1);
    const dd = leftPad2(value.getDate());
    const hh = leftPad2(value.getHours());
    const mm = leftPad2(value.getMinutes());
    const ss = leftPad2(value.getSeconds());
    return `${yyyy}-${MM}-${dd} ${hh}:${mm}:${ss}`;
};

const FeatureFlagsEdit: React.FC = (props: any) => {
  return (
    <Edit {...props}>
      <SimpleForm>
        <TextInput source='id' disabled/>
        <TextInput
          source='internalName'
          fullWidth
          validate={[
            required()
          ]}
        />
        <TextInput
          source='displayName'
          fullWidth
          validate={[
            required()
          ]}
        />
        <TextInput
          source='enableDatetime'
          defaultValue={convertDateToString(new Date())}
          validate={[
            required()
          ]}
        />
      </SimpleForm>
    </Edit>
  );
};

export default FeatureFlagsEdit;